import fetcher from '../fetcher'

import type { Category } from './types'
import config from '../../config'

/**
 * Returns all children categories of parentId category.
 * if @param parentId is null, it will return all categories without parent (level 1)
 * @returns Array<Category>
 */
export const getCategories = async (_: string, parentId?: string | null | undefined): Promise<Array<Category>> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/categories/${parentId ?? ''}`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching children categories: ${error}`)
    throw error
  }
}
